<template>
  <template v-if="isShowCreateOrganization || isShowOnboarding || isShowOnboardingAi">
    <CreateOrganizationModal
      v-if="isShowCreateOrganization"
      is-edit
      @close-create-organization="$emit('close-create-organization')"
    />

    <OnboardingHub v-else-if="isShowOnboarding" @close-onboarding="$emit('close-onboarding')" />

    <OnboardingAiHub
      v-else-if="isShowOnboardingAiLocal"
      @close-onboarding-ai="$emit('close-onboarding-ai')"
    />

    <OboardLogoLoader v-if="!isShowOnboardingAiLocal" />
  </template>

  <template v-else>
    <template v-if="isShowLayout">
      <router-view />

      <InAppNotifications ref="inAppNotifications" />
    </template>
  </template>
</template>

<script>
import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'

import { handleError } from '@/utils/error-handling'
import { isAzureAppInjectionKey, isJiraAppInjectionKey } from '@/utils/injection-keys'
import CreateOrganizationModal from '@shared-modules/components/modals/CreateOrganizationModal'

import InAppNotifications from '@/components/ui/InAppNotifications/InAppNotifications'
import OnboardingHub from '@/components/ui/onboarding/OnboardingHub'
import OnboardingAiHub from '@/components/ui/onboarding-ai/OnboardingAiHub'
import OboardLogoLoader from '@/components/ui/SkeletonLoaders/OboardLogoLoader'

export default defineComponent({
  name: 'MainLayout',
  components: {
    CreateOrganizationModal,
    OboardLogoLoader,
    OnboardingAiHub,
    OnboardingHub,
    InAppNotifications
  },

  inject: {
    isJiraApp: {
      from: isJiraAppInjectionKey
    },

    isAzureApp: {
      from: isAzureAppInjectionKey
    }
  },

  beforeRouteEnter(to, _, next) {
    next(vm => {
      vm.fetchInitialData(+to.params.workspaceId)
    })
  },

  beforeRouteUpdate(to, from, next) {
    if (to.name !== from.name) {
      // added optional chaining coz while onboarding
      // we add to route query param redirectTo=first-alignment
      // and this triggers beforeRouteUpdate,
      // but we don't show InAppNotifications
      // and all router-view by condition settingsAreLoaded
      this.$refs.inAppNotifications?.getInitialNotifications()
    }
    next()
  },

  props: {
    isShowOnboarding: {
      type: Boolean
    },

    isShowOnboardingAi: {
      type: Boolean
    },

    isShowCreateOrganization: {
      type: Boolean
    }
  },

  emits: {
    'close-onboarding': null,
    'close-onboarding-ai': null,
    'close-create-organization': null
  },

  computed: {
    ...mapState('system', {
      settingsAreLoaded: state => state.settingsAreLoaded
    }),

    ...mapState('azureDevops', {
      workItemsAreLoaded: state => state.workItemsAreLoaded
    }),

    isShowLayout() {
      const baseCondition = this.settingsAreLoaded

      if (this.isAzureApp) {
        return baseCondition && this.workItemsAreLoaded
      }

      return baseCondition
    },

    isShowOnboardingAiLocal() {
      return this.isShowOnboardingAi && this.settingsAreLoaded
    }
  },

  methods: {
    ...mapActions('system', {
      fetchInitData: 'fetchInitData'
    }),

    // eslint-disable-next-line vue/no-unused-properties
    async fetchInitialData(initialWorkspaceId) {
      try {
        await this.fetchInitData({
          initialWorkspaceId
        })
      } catch (error) {
        handleError({ error })
      }
    }
  }
})
</script>

<style lang="scss" scoped></style>
